import { withStyles } from '@material-ui/core';

import Autocomplete from '@/components/Autocomplete';

import styles from './styles';

export default withStyles(styles)(Autocomplete);
